(ns practitest.frontend.components.modal
  (:require ["react-bootstrap/Modal" :as Modal]
            [reagent.core :as reagent]))

(defn bootstrap-modal
  [{:keys [is-open?
           on-request-close
           container-ref
           class
           close-button?
           scrollable?
           centered?
           title-class
           ;; Modal.Title renders a div with Bootstrap's `h4` class, whose font-weight and
           ;; font-size leak into custom headers. Pass e.g. "div" to render without it.
           title-as
           footer-class
           ;; When false, the user can't dismiss the modal via backdrop click or Escape -
           ;; only via an explicit in-modal action (e.g. a button dispatching on-request-close).
           dismissible?
           enforce-focus?
           test-id]
    :or   {dismissible? true enforce-focus? true}
    :as   props}
   header
   body
   footer]
  [:r> Modal
   #js {:show            (boolean is-open?)
        :onHide          on-request-close
        :dialogClassName class
        :scrollable      scrollable?
        :centered        centered?
        :backdrop        (if dismissible? true "static")
        :keyboard        dismissible?
        :enforceFocus    (boolean enforce-focus?)
        :data-testid     test-id
        :container       (when container-ref
                           (fn []
                             @container-ref))}
   (when header
     [:r> (.-Header Modal) #js {:closeButton (boolean close-button?)}
      ;; `as` is only set when given - react-bootstrap's default applies to undefined, not null.
      [:r> (.-Title Modal) (clj->js (cond-> {:className title-class}
                                      title-as (assoc :as title-as)))
       (reagent/as-element
         [:div.modal-title-content header])]])
   (when body
     [:r> (.-Body Modal) #js {}
      (reagent/as-element
        body)])
   (when footer
     [:r> (.-Footer Modal) #js {:className footer-class}
      (reagent/as-element footer)])])

(defn modal-with-notifications
  "A bootstrap-modal whose footer is a notifications area.
   `notifications` is a collection of toast elements (see
   practitest.frontend.components.notifications/toast-element); when empty no
   footer is rendered. `modal-props`, `header` and `body` are passed through to
   bootstrap-modal."
  [modal-props header body notifications]
  [bootstrap-modal
   (assoc modal-props :footer-class "modal-notifications-footer")
   header
   body
   (when (seq notifications)
     (into [:div.notifications-container] notifications))])
